// removed by extract-text-webpack-plugin
module.exports = {"block":"BrandDownloadPanel_block_CnYdE","button":"BrandDownloadPanel_button_ZHnq1","active":"BrandDownloadPanel_active_3naIw","fileSize":"BrandDownloadPanel_fileSize_3sgX9"};